import { render, staticRenderFns } from "./LeftDetail.vue?vue&type=template&id=3b9c528c&scoped=true&"
import script from "./LeftDetail.vue?vue&type=script&lang=js&"
export * from "./LeftDetail.vue?vue&type=script&lang=js&"
import style0 from "./LeftDetail.vue?vue&type=style&index=0&id=3b9c528c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9c528c",
  null
  
)

export default component.exports